export const DISH_OPTIONS_CATEGORY_GET_REQUEST = 'DISH_OPTIONS_CATEGORY_GET_REQUEST';
export const DISH_OPTIONS_CATEGORY_GET_SUCCESS = 'DISH_OPTIONS_CATEGORY_GET_SUCCESS';
export const DISH_OPTIONS_CATEGORY_GET_FAILURE = 'DISH_OPTIONS_CATEGORY_GET_FAILURE';

export const DISH_OPTIONS_CATEGORY_GET_BY_ID_REQUEST = 'DISH_OPTIONS_CATEGORY_GET_BY_ID_REQUEST';
export const DISH_OPTIONS_CATEGORY_GET_BY_ID_SUCCESS = 'DISH_OPTIONS_CATEGORY_GET_BY_ID_SUCCESS';
export const DISH_OPTIONS_CATEGORY_GET_BY_ID_FAILURE = 'DISH_OPTIONS_CATEGORY_GET_BY_ID_FAILURE';

export const DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_REQUEST = 'DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_REQUEST';
export const DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_SUCCESS = 'DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_SUCCESS';
export const DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_FAILURE = 'DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_FAILURE';

export const DISH_OPTIONS_CATEGORY_DELETE_REQUEST = 'DISH_OPTIONS_CATEGORY_DELETE_REQUEST';
export const DISH_OPTIONS_CATEGORY_DELETE_SUCCESS = 'DISH_OPTIONS_CATEGORY_DELETE_SUCCESS';
export const DISH_OPTIONS_CATEGORY_DELETE_FAILURE = 'DISH_OPTIONS_CATEGORY_DELETE_FAILURE';

export const RESET_DISH_OPTIONS_CATEGORY_ERRORS = 'RESET_DISH_OPTIONS_CATEGORY_ERRORS';

export const CHANGE_DISH_OPTIONS_FORM_STEP = 'CHANGE_DISH_OPTIONS_FORM_STEP';

export const RESET_DISH_OPTIONS_LIST_DATA = 'RESET_DISH_OPTIONS_LIST_DATA';
